import { Group, Modal, Text } from '@mantine/core';
import { Button } from 'src/design-system/Button';
import {
  ARTIFACT_LABELS,
  type RegeneratableArtifact,
} from 'src/meetings/hooks/useRegenerateMeetingArtifacts';

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  artifacts: RegeneratableArtifact[];
  isRegenerating: boolean;
};

function buildMessage(artifacts: RegeneratableArtifact[]): string {
  const labels = artifacts.map(artifact => ARTIFACT_LABELS[artifact]);
  const isPlural = labels.length > 1;
  const list = isPlural
    ? `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
    : (labels[0] ?? '');
  const verb = isPlural ? 'were' : 'was';
  const pronoun = isPlural ? 'them' : 'it';
  return `You've changed who's in this meeting. The ${list} ${verb} generated from the previous participants and may now be out of date. Would you like to regenerate ${pronoun}?`;
}

export function RegenerateArtifactsModal({
  opened,
  onClose,
  onConfirm,
  artifacts,
  isRegenerating,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Regenerate meeting outputs"
      centered
      closeOnClickOutside={!isRegenerating}
      closeOnEscape={!isRegenerating}
      withCloseButton={!isRegenerating}
    >
      <Text mb="md" size="sm" c="gray.8">
        {buildMessage(artifacts)}
      </Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="secondary" onClick={onClose} disabled={isRegenerating}>
          Not now
        </Button>
        <Button variant="primary" onClick={onConfirm} loading={isRegenerating}>
          Regenerate
        </Button>
      </Group>
    </Modal>
  );
}
